import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { updateBatchClaimsOfficeallyStatus } from './actions/index';
import { CancelButton } from '../../../../components/buttons';
import SmallLoader from '../../../../img/small-loader.gif';
import { renderAutoCompleteSingleSelect } from "../../../../components/reduxFields";
// import validate from './validate';



class UpdateBatchClaimOfficeallyStatusModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            selectedLedgerClaimIds: this.props.selectedLedgerClaimIds.length > 0 ? this.props.selectedLedgerClaimIds : []
        };
    }

    handleClose = () => {
        this.props.closeDialog();
    };

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };
    }

    handleNewRequest(input, selectedValue) {
        input.onChange(selectedValue.value);
        this.props.updateBatchClaimsOfficeallyStatus(this.state.selectedLedgerClaimIds, selectedValue.value, this.props.searchObj);
        this.setState({ open: false });
        this.props.closeDialog();
    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const actions = [
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />
        ];
        return (
            <Dialog
                className="custom_modal"
                title="Update Batch Claim Officeally Status"
                modal={false}
                open={this.state.open}
                actions={actions}
                autoScrollBodyContent={true}
            >
                <div className="row">
                    <div className="col-sm-12">
                        <form className="readmin-form custom_form">
                            <div className="row">
                                <div className="col-sm-12 require" style={{ marginTop: '50px' }}>
                                    <Field
                                        name={`claimOfficeallyStatusId`}
                                        hintText="Status"
                                        handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue)}
                                        options={this.props.masterClaimOfficeallyStatus}
                                        component={renderAutoCompleteSingleSelect}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </Dialog>
        );
    }
}

UpdateBatchClaimOfficeallyStatusModal = reduxForm({
    form: 'UpdateBatchClaimOfficeallyStatusModalForm',
    // validate,
    enableReinitialize: true,
})(UpdateBatchClaimOfficeallyStatusModal);


function mapStateToProps(state, ownProps) {
    return {
        loading: false 
    }
}

export default connect(mapStateToProps, {updateBatchClaimsOfficeallyStatus})(UpdateBatchClaimOfficeallyStatusModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/Ledger/UpdateBatchClaimOfficeallyStatusModal.js